import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/.pnpm/@apollo+client-react-streaming@0.12.2_@apollo+client@3.13.8_@types+react@19.1.3_graphql_9110531a717c88025249f8432e78e9b8/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["useStoreLocatorUrl"] */ "/app/src/feature/store-locator/hooks/useStoreLocatorLink.client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["CategoriesSlider"] */ "/app/src/feature/universe/components/categories-slider/CategoriesSlider.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracking"] */ "/app/src/lib/tracking/components/PageTracking.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/app/src/ui/breadcrumb/Breadcrumb.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/buttons/button/Button.css");
;
import(/* webpackMode: "eager", webpackExports: ["Callout"] */ "/app/src/ui/callout/Callout.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/links/link/Link.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/media/picture/Picture.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/text/inner-html/InnerHtml.client.tsx");
